import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';

class SidebarContent extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    menuName: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    childrenMenu: PropTypes.arrayOf(PropTypes.shape).isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };

  render() {
    const { menuName, icon } = this.props;
    const { childrenMenu } = this.props;
    let menuConten = null;
    if (childrenMenu) {
      menuConten = childrenMenu.map((menuItem) => (
        <SidebarLink
          key={menuItem.id}
          title={menuItem.name}
          route={'/minime/'.concat(menuItem.route)}
          onClick={this.hideSidebar}
        />
      ));
    }
    return (
      <div className="sidebar__content">
        <ul className="sidebar__block">
          <SidebarCategory title={menuName} icon={icon}>
            {menuConten}
          </SidebarCategory>
        </ul>
      </div>
    );
  }
}

export default SidebarContent;
